import React, { FC, useState } from 'react';

import { FieldErrorList, FormField, Input, Label, ToggleSwitch } from 'common/components';
import InputWithSearchIcon from 'common/components/base/input-with-search-icon';
import { InputType } from 'common/enums';
import { FieldError } from 'common/models';
import { INDICATOR_SEARCH_COUNTRIES } from 'common/config';
import { IndicatorLocationTemp } from 'common/models/data/indicator.model';

import './IndicatorCountryList.scss';

type IndicatorCountryListProps = {
    data: IndicatorLocationTemp[];
    fieldErrors: Array<FieldError>;
    hideErrorToggle?: boolean;
    onChange: (countryName: string, value: string) => void;
};

const IndicatorCountryList: FC<IndicatorCountryListProps> = ({
    data,
    fieldErrors,
    hideErrorToggle,
    onChange
}: IndicatorCountryListProps) => {
    const [searchValue, setSearchValue] = useState('');
    const [isShowError, setShowError] = useState<boolean>(false);

    const onSearchChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value);
    };

    const getCountryData = () => {
        if (isShowError && fieldErrors.length === 0) {
            return [];
        }
        const dataError = (d: IndicatorLocationTemp) => d.hasError === true;
        data = isShowError ? data.filter(dataError) : data;
        if (searchValue && searchValue.length > 0) {
            data = data.filter((ctry: IndicatorLocationTemp) =>
                ctry.locationName.toLowerCase().includes(searchValue.toLowerCase())
            );
        }
        return data.sort((a, b) => a.locationName.localeCompare(b.locationName));
    };

    return (
        <div className="indicator-country-list-container">
            <div className="search-panel">
                <InputWithSearchIcon
                    placeholder={INDICATOR_SEARCH_COUNTRIES}
                    className="search-input"
                    value={searchValue}
                    onChange={onSearchChangeHandler}
                />
                {hideErrorToggle !== true && (
                    <FormField className="toggle-error">
                        <Label text="Display Errors only"></Label>
                        <ToggleSwitch
                            id="tsShowError"
                            onLabel=""
                            offLabel=""
                            checked={isShowError}
                            onChange={(event: any) =>
                                setShowError(event.target.checked)
                            }></ToggleSwitch>
                    </FormField>
                )}
            </div>
            <div className="indicator-country-header-container indicator-country-header">
                <div className="country-name">Country</div>
                <div className="country-values">Values</div>
            </div>

            <div className="indicator-country-list">
                {getCountryData().map((country: IndicatorLocationTemp) => {
                    return (
                        <div key={country.locationId} className="indicator-country">
                            <div className="country-name">{country.locationName}</div>
                            <FormField className="input-value-container">
                                <Input
                                    type={InputType.TEXT}
                                    value={country.value || ''}
                                    className="input-value-field"
                                    hideClearButton
                                    onChange={(event) => {
                                        onChange(country.locationName, event.target.value);
                                    }}
                                />
                                <FieldErrorList field={country.locationName} errors={fieldErrors} />
                            </FormField>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default IndicatorCountryList;
